import React from "react"
import cn from "classnames"
import { Field, FieldRenderProps } from "react-final-form"
import Slider, { TrackVariant } from "../controls/Slider";

interface SliderFieldProps {
  className?: string;
  id?: string;
  i18key?: string;
  mainLabel?: string;
  max: number;
  min: number;
  name: string;
  showCurrentValue?: boolean;
  risingBg?: boolean;
  showMinMaxLabels?: boolean;
  step?: number;
  trackVariant?: TrackVariant;
  valueToString?: (n: number) => string;
}

const SliderField: React.FC<SliderFieldProps> = (props: SliderFieldProps) => {
  const {
    className, id, mainLabel, max, min, name, showCurrentValue, risingBg, showMinMaxLabels, step, trackVariant
  } = props;
  const valueToString = props.valueToString || String
  return (
    <Field
      className={className}
      max={max}
      min={min}
      name={name}
      step={step}
      type="number"
      render={({ className, input, max, min, step }: FieldRenderProps<number>): React.ReactNode => {
        const { value } = input
        return (
          <div className={cn("SliderField", className)}>
            {(mainLabel || showCurrentValue) && (
              <div className="SliderField-labels">
                <div>{mainLabel}</div>
                <div className="font-bold text-3xl">{valueToString(value)}</div>
              </div>
            )}
            <Slider
              risingBg={risingBg}
              input={input}
              max={max as number}
              min={min as number}
              step={step as number}
              trackVariant={trackVariant}
            />
            {id && <input id={id} type="hidden" value={value}/>}
            {showMinMaxLabels &&
              <div className="SliderField-minMaxLabels">
                <div>{valueToString(min)}</div>
                <div>{valueToString(max)}</div>
              </div>
            }
          </div>
        )
      }}
    />
  )
}

export default SliderField
